import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.loadPreferences()
  }

  async loadPreferences() {
    try {
      // Essayer de charger depuis le localStorage d'abord
      const localPreferences = this.getLocalPreferences()
      if (localPreferences && localPreferences.length > 0) {
          return
      }

      // Si rien dans localStorage, charger depuis le backend
      const response = await fetch('/settings.json')
      if (response.ok) {
        const data = await response.json()
        this.saveLocalPreferences(data.hidden_channels)
        }
    } catch (error) {
      console.warn('Erreur lors du chargement des préférences:', error)
    }
  }

  getLocalPreferences() {
    try {
      const stored = localStorage.getItem('tv_hidden_channels')
      return stored ? JSON.parse(stored) : null
    } catch (e) {
      console.warn('Erreur de lecture localStorage:', e)
      return null
    }
  }

  saveLocalPreferences(channels) {
    try {
      localStorage.setItem('tv_hidden_channels', JSON.stringify(channels))
    } catch (e) {
      console.warn('Erreur de sauvegarde localStorage:', e)
    }
  }

  clearPreferences() {
    try {
      localStorage.removeItem('tv_hidden_channels')
    } catch (e) {
      console.warn('Erreur de suppression localStorage:', e)
    }
  }
}